/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';
import { _date } from '@mairistem/administres-utils';
import { Table } from '@mairistem/composants';

import type { Acte } from '@/types';
import { trimComma } from '@/utils';

interface Props {
  acte: Acte;
}

const ActeTableLinePacs = ({ acte }: Props) => (
  <>
    <Table.Cell content={_date.short(acte.dateEnregistrement ?? '')} />
    <Table.Cell content={trimComma(acte.partenaire1NomClassement)} />
    <Table.Cell content={trimComma(acte.partenaire2NomClassement)} />
  </>
);

export default ActeTableLinePacs;
